export interface IMapPromiseOption {
  concurrency: number;
}
